var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "mt-8 leading-6 text-disclosure"
  }, [_vm._v("\n\tBy clicking Continue, I agree to\n\t"), _c('a', {
    staticClass: "text-lead underline btn-arrow",
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.showThisDisclosure('Terms_of_Service')).apply(null, arguments);
      }
    }
  }, [_vm._v("Terms of Service")]), _vm._v(",\n\t"), _c('a', {
    staticClass: "text-lead underline btn-arrow",
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.showThisDisclosure('Privacy_Policy')).apply(null, arguments);
      }
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(", and\n\t"), _c('a', {
    staticClass: "text-lead underline btn-arrow",
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.showThisDisclosure('Extra_Electronic_Communications_Agreement')).apply(null, arguments);
      }
    }
  }, [_vm._v("Electronic and Telephone Disclosure")]), _vm._v(".\n")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };